<template>
    <div>
        <portal v-if="$device.isMobileOrTablet" selector="body">
            <BgOverlay v-if="$device.isMobileOrTablet" :is-open="isOpen" class="z-50" />
        </portal>

        <MultiSelect
            v-model="model"
            :options="options"
            :option-label="optionLabel"
            :placeholder="$t('generic.choose_prompt')"
            :filter="true"
            :class="{
                'p-component-light': light,
                'p-multiselect-open': isOpen && !$device.isMobileOrTablet,
                'p-multiselect-wide': hasWideDropdownPanel,
                'panel-always-below': isPanelAlwaysBelow,
            }"
            :append-to="$device.isMobileOrTablet ? 'body' : undefined"
            :disabled="!options.length"
            :show-toggle-all="false"
            @show="show"
            @hide="hide"
        />
    </div>
</template>

<script>
import BgOverlay from '@/components/UI/BgOverlay';

export default {
    name: 'MultiSelectFilter',
    components: {
        BgOverlay,
    },
    props: {
        value: {
            type: Array,
            required: false,
            default: null,
        },
        set: {
            type: Function,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        optionLabel: {
            type: String,
            required: false,
            default: 'title',
        },
        hasWideDropdownPanel: {
            type: Boolean,
            required: false,
            default: false,
        },
        light: {
            type: Boolean,
            required: false,
            default: false,
        },
        isPanelAlwaysBelow: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        model: {
            get() {
                if (!this.value) {
                    return null;
                }
                return this.$clone(this.value).sort((a, b) => b.id - a.id);
            },
            set(val) {
                this.set(val);
            },
        },
    },
    methods: {
        show() {
            this.isOpen = true;
            if (this.$device.isMobileOrTablet) {
                this.$disableBodyScroll(document.querySelector('.p-multiselect-items-wrapper'));
            }
        },
        hide() {
            if (this.$device.isMobileOrTablet) {
                this.$enableBodyScroll(document.querySelector('.p-multiselect-items-wrapper'));
            }
            this.isOpen = false;
        },
    },
};
</script>

<style scoped></style>
